import { internFrontEndDeveloper } from './items/intern-front-end-developer';
import { freelancerBackEndDeveloper } from './items/freelancer-back-end-developer';

export const careersList = [freelancerBackEndDeveloper, internFrontEndDeveloper];
